// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__10PBI","col":"Table_col__3pkl1","fulfillmentStatus":"Table_fulfillmentStatus__3iwHc","emailCol":"Table_emailCol__2lKEN"};